export function lessThanNumeric(lessThan, greaterThan) {
	return lessThan - greaterThan;
}
